import {
    CreateBase,
    Form,
    Identifier,
    RaRecord,
    SaveButton,
    useGetIdentity,
    useListContext,
    useNotify,
    useRecordContext,
    useResourceContext,
    useUpdate,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { Stack } from '@mui/material';
import { NoteInputs } from './NoteInputs';
import { getCurrentDate } from './utils';

const foreignKeyMapping = {
    suppliercontacts: 'id_contato',
    deals: 'deal_id',
};

export const NoteCreate = ({
    showStatus,
    reference,
}: {
    showStatus?: boolean;
    reference: 'suppliercontacts' | 'deals';
}) => {
    const resource = useResourceContext();
    const record = useRecordContext();
    const { identity } = useGetIdentity();

    if (!record || !identity) return null;
    return (
        <CreateBase resource={resource} redirect={false}>
            <Form>
                <NoteInputs showStatus={showStatus} />
                <Stack direction="row">
                    <NoteCreateButton reference={reference} record={record} />
                </Stack>
            </Form>
        </CreateBase>
    );
};

const NoteCreateButton = ({
    reference,
    record,
}: {
    reference: 'suppliercontacts' | 'deals';
    record: RaRecord<Identifier>;
}) => {
    const [update] = useUpdate();
    const notify = useNotify();
    const { identity } = useGetIdentity();
    const { reset } = useFormContext();
    const { refetch } = useListContext();

    if (!record || !identity) return null;

    const resetValues: {
        texto_atividade: null;
        attachments: null;
        dthr_tarefa: null;
        status?: string;
    } = {
        texto_atividade: null,
        attachments: null,
        dthr_tarefa: null,
    };

    // if (reference === 'suppliercontacts') {
    //     resetValues.status = 'warm';
    // }

    const handleSuccess = (data: any) => {
        reset(resetValues, { keepValues: false });
        refetch();
        update(reference, {
            id: (record && record.id) as unknown as Identifier,
            data: { ...record },
            previousData: record,
        });
        notify('Anotação adicionada');
    };
    return (
        <SaveButton
            type="button"
            label="Adicionar anotação"
            variant="contained"
            transform={data => ({
                ...data,
                [foreignKeyMapping[reference]]: record.id,
                id_pessoa: record.id_pessoa,
            })}
            mutationOptions={{
                onSuccess: handleSuccess,
            }}
        />
    );
};
